import { Separator, VStack } from "@chakra-ui/react"
import HomeSuperUserAugmentationPathCopy from "./HomeSuperUserAugmentationPathCopy"
import HomeSuperUserAugmentationTips from "./HomeSuperUserAugmentationTips"

const HomeSuperuserAugmentation = () => {
  return (
    <VStack w="100%" minH="100%" maxH="100%">
      <HomeSuperUserAugmentationTips />
      <Separator borderBottomWidth={0} borderTopWidth="1px" w="full" />
      <HomeSuperUserAugmentationPathCopy />
    </VStack>
  )
}

export default HomeSuperuserAugmentation
